
const digest = '02248d4da75f6f80e2078d556e891df519dff9b4dd7fd3f69f5b70967692fe2a';
const classes = {"header":"_header_17xx2_1"};
const css = `._header_17xx2_1 {
  display: flex;
  flex-direction: column;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  